import { render } from "./SidebarBtn.vue?vue&type=template&id=05a98184&scoped=true"
import script from "./SidebarBtn.vue?vue&type=script&lang=js"
export * from "./SidebarBtn.vue?vue&type=script&lang=js"

import "./SidebarBtn.vue?vue&type=style&index=0&id=05a98184&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a98184"]])

export default __exports__